import React, { useEffect, useRef, useState } from "react";
import Tooltip from "../../../../../../Components/Tooltip/Tooltip";
import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";

const AddressSelector = ({ AddressBook, handleaddress }) => {
  const [activeId, setActiveId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5); // Default fallback
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        const buttonWidth = 110; // Estimate per item (px), including margin
        const buttonsThatFit = Math.floor((containerWidth - 100) / buttonWidth); // -100 for arrows
        setItemsPerPage(Math.max(1, buttonsThatFit));
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const totalPages = Math.ceil(AddressBook.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = AddressBook.slice(startIndex, startIndex + itemsPerPage);

  const handleClick = (id) => {
    setActiveId(id);
    handleaddress(id);
  };

  return (
    <div
      ref={containerRef}
      className="flex items-center justify-center space-x-2 overflow-x-auto whitespace-nowrap"
    >
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setCurrentPage((p) => Math.max(p - 1, 1));
        }}
        disabled={currentPage === 1}
        className={`text-sm px-1 py-1 border rounded flex-shrink-0 transition-colors
          ${
            currentPage === 1
              ? "text-ui-text-subtle cursor-not-allowed"
              : "text-brand hover:bg-brand-light"
          }
        `}
      >
        <MdNavigateBefore className="w-4 h-4" />
      </button>

      {currentItems.map((address, index) => {
        const realIndex = startIndex + index + 1;
        return (
          <div key={realIndex} className="relative group flex-shrink-0">
            <Tooltip title={address.company}>
              <button
                type="button"
                onClick={() => handleClick(realIndex)}
                className={`text-sm px-1 py-1 border rounded max-w-[110px] min-w-[60px] truncate transition-colors
                ${
                  realIndex === activeId
                    ? "bg-brand text-white"
                    : "hover:bg-brand-light hover:text-brand"
                }
              `}
              >
                {address.company}
              </button>
            </Tooltip>
          </div>
        );
      })}

      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setCurrentPage((p) => Math.min(p + 1, totalPages));
        }}
        disabled={currentPage === totalPages}
        className={`text-sm px-1 py-1 border rounded flex-shrink-0 transition-colors
          ${
            currentPage === totalPages
              ? "text-ui-text-subtle cursor-not-allowed"
              : "text-brand hover:bg-brand-light"
          }
        `}
      >
        <MdNavigateNext className="w-4 h-4" />
      </button>
    </div>
  );
};

export default AddressSelector;
